const localStorageName = 'quantiply-admin-panel-local';

const getComplete = () => {
  // Create storage if none exists
  if (!localStorage.getItem(localStorageName)) {
    localStorage.setItem(localStorageName, JSON.stringify({}));
  }

  return JSON.parse(localStorage.getItem(localStorageName));
};

const getItem = (name) => {
  const store = getComplete();

  if (!store[name]) return '';

  return store[name];
};

const setItems = (list = {}) => {
  // List = { filed: 'value' }
  const store = getComplete();

  const newStore = JSON.stringify(Object.assign({}, store, list));

  localStorage.setItem(localStorageName, newStore);
};

const deleteItem = (name) => {
  const store = getComplete();

  if (!store[name]) return;

  delete store[name];

  localStorage.setItem(localStorageName, JSON.stringify(store));
};

const clear = () => {
  localStorage.setItem(localStorageName, JSON.stringify({}));
};

const deleteComplete = () => {
  localStorage.removeItem(localStorageName);
};

export default {
  getComplete,
  getItem,
  setItems,
  deleteItem,
  clear,
  deleteComplete,
};
